/** /symbol/fake/: a deliberately fake label, drawn by the page itself: no symbol, or a symbol that isn't yours. */
void (async () => {
  try {
    const r = await fetch('/api/symbol/decoy', { credentials: 'same-origin', cache: 'no-store' });
    const j = (await r.json()) as { symbol: { svg: string; name: string } };
    const box = document.getElementById('fake-sym')!;
    box.innerHTML = j.symbol.svg;
  } catch {}
})();
export {};
